module.exports = __webpack_public_path__ + "static/media/lightningGamesPlayed_100_250.05eb1141.png";